import { tokens } from 'ComponentLibrary/style-dictionary/output'

export const SOURCE_COLORS = [
    tokens.ColorGraphSequentialOneMedium,
    tokens.ColorGraphSequentialTwoMedium,
    tokens.ColorGraphSequentialThreeMedium,
    tokens.ColorGraphSequentialFourMedium,
    tokens.ColorGraphSequentialFiveMedium,
    tokens.ColorGraphSequentialSixMedium,
    tokens.ColorGraphSequentialSevenMedium,
    tokens.ColorGraphSequentialEightMedium,
    tokens.ColorGraphSequentialNineMedium,
    tokens.ColorGraphSequentialTenMedium,
]

export const getSourceColor = (index: number) => SOURCE_COLORS.at(index % SOURCE_COLORS.length) as string
